export default __webpack_public_path__ + "static/media/weight.5f19df26.svg";